export default __webpack_public_path__ + "static/media/1.b48d40e7.png";